import React from "react";

import ActionsDropdown from "../../../../../components/Dropdown/ActionsDropdown";
import {
  DateFormat,
  formatCurrency,
  formatDate,
  formatSignedPercent,
} from "../../../../../utils";
import { MarketUpdateItemProps } from "./types";
import {
  Row,
  DateCell,
  ValueCell,
  ChangeCell,
  PercentCell,
  MutedCell,
  KebabCell,
} from "./styles";

export const MarketUpdateRow: React.FC<MarketUpdateItemProps> = ({
  item,
  actions,
}) => {
  const hasChange = item.changeValue !== null;
  const isPositive = (item.changeValue ?? 0) >= 0;

  const changeText = hasChange ? formatCurrency(item.changeValue) : "—";
  const percentText =
    item.changePercent === null ? "—" : formatSignedPercent(item.changePercent);

  return (
    <Row>
      <DateCell>{formatDate(item.date, DateFormat.DMY_SPACE)}</DateCell>
      <ValueCell>{formatCurrency(item.value)}</ValueCell>
      {hasChange ? (
        <ChangeCell $positive={isPositive}>{changeText}</ChangeCell>
      ) : (
        <MutedCell $isPercentage={false}>{changeText}</MutedCell>
      )}
      {item.changePercent ? (
        <PercentCell $positive={isPositive}>{percentText}</PercentCell>
      ) : (
        <MutedCell $isPercentage={true}>{percentText}</MutedCell>
      )}
      <KebabCell>
        {actions.length > 0 && (
          <ActionsDropdown
            compact
            dropdownActions={actions}
            testId={`market-update-actions-${item.id}`}
          />
        )}
      </KebabCell>
    </Row>
  );
};
